import { DropdownOption } from "src/models";
import { ContactUsTypes } from "../types";
import { createAction } from "./create.action";

export namespace ContactUsAction {

    export const submit = (model: Record<string, any>) => createAction(ContactUsTypes.SUBMIT_CONTACT_US, model);
    export const submitted = (succeed: boolean) => createAction(ContactUsTypes.CONTACT_US_SUBMITTED, succeed);

    export const getFeedbackTypes = () => createAction(ContactUsTypes.GET_FEEDBACK_TYPES);
    export const setFeedbackTypes = (types: DropdownOption[]) => createAction(ContactUsTypes.SET_FEEDBACK_TYPES, types);

}